import _ from 'underscore'
import resolve from 'ioc/resolve'
import $pageConfig from 'webutils/services/page-config'
import $session from 'servicestack/session'
import templateUrl from 'emun.on-demand/layers/design-layer-editor.htm'
import webcolors from 'webcolors/webcolors'
import webfonts from 'webfonts/webfonts'


class DesignLayerEditorController {
    constructor($scope, $transclude) {
        var $ctrl = this;
        $ctrl.webcolors = webcolors;
        $ctrl.$pageConfig = $pageConfig;
        $ctrl.$session = $session;
        $ctrl.isSlotFilled = $transclude.isSlotFilled;
        $scope.sl = $ctrl.layer;
    }
    $onInit() {
        var $ctrl = this;
        //$ctrl.designer.layers.all.forEach(l => {
        //    webcolors.addRecent(l.get('fill'));
        //    webfonts.addRecent(l.get('fontFamily'));
        //});
    }
}

let DesignLayerEditor = {
    bindings: {
        layer : '<',
        designer : '<',
        title: '@',
        hideHeader: '@',
        hideFooter: '@',
        onDismiss: '&',
        onClose: '&',
    },
    transclude: {
        header: '?designLayerEditorHeader',
        //title: '?designLayerEditorTitle',
        lineage: '?designLayerEditorLineage',
        body: '?designLayerEditorBody',
        footer: '?designLayerEditorFooter'
    },
    controller: DesignLayerEditorController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignLayerEditor;